import socketio from 'socket.io-client'
import { ChatMessageBus } from '@/emitter/ChatMessageBus'
import ApiUtils from '@/utils/ApiUtils'



const ChatMessageService =  {

  io: socketio.connect('https://api.hublot.io', {
    path: '/chat/v2/socket.io',
    transports: ['websocket'],
    reconnection: true,
  }),
  currentSerial: null, // Garder une trace du serial actuel
  updateIo() {
    ChatMessageService.io = socketio.connect(ApiUtils().backend, {
      path: '/chat/v2/socket.io/',
      transports: ['websocket'],
      reconnection: true,
    })
  },
  joinAndListen(serial) {
    return new Promise((resolve) => {
      // Si on était déjà connecté à une room, on la quitte d'abord
      if (ChatMessageService.currentSerial && ChatMessageService.currentSerial !== serial) {
        ChatMessageService.io.emit('leave_room', ChatMessageService.currentSerial)
      }
      
      // Retirer les anciens listeners pour éviter les doublons
      ChatMessageService.io.off('message_received', ChatMessageService.onMessageReceived)
      ChatMessageService.io.off('seen_received', ChatMessageService.getLastMessageSeen)
      ChatMessageService.io.off('message_edited', ChatMessageService.onMessageEdited)
      ChatMessageService.io.off('message_deleted', ChatMessageService.onMessageDeleted)
      ChatMessageService.io.off('typing', ChatMessageService.onTyping)
      
      // Ajouter les nouveaux listeners
      ChatMessageService.io.on('message_received', ChatMessageService.onMessageReceived)
      ChatMessageService.io.on('seen_received', ChatMessageService.getLastMessageSeen)
      ChatMessageService.io.on('message_edited', ChatMessageService.onMessageEdited)
      ChatMessageService.io.on('message_deleted', ChatMessageService.onMessageDeleted)
      ChatMessageService.io.on('typing', ChatMessageService.onTyping)
      ChatMessageService.io.emit('join_room', serial, () => {
        ChatMessageService.currentSerial = serial
        resolve()
      })
    })
  },
  getSocket() {
    return ChatMessageService.io
  },
  onMessageReceived(payload) {
    ChatMessageBus.$emit('message_received', payload)
  },
  getLastMessageSeen(lastSeen_time){
    ChatMessageBus.$emit('seen_received', lastSeen_time)
  },
  onMessageEdited(payload) {
    ChatMessageBus.$emit('message_edited', payload)
  },
  onMessageDeleted(payload) {
    ChatMessageBus.$emit('message_deleted', payload)
  },
  // HUB-831 : « X est en train d'écrire » — éphémère, relayé entre pods par le service
  onTyping(payload) {
    ChatMessageBus.$emit('typing', payload)
  },
  sendTyping(payload) {
    ChatMessageService.io.emit('typing', payload)
  },
  getMessages(serial, limit = 50, offset = 0) {
    return new Promise((resolve, reject) => {
      ChatMessageService.io.emit(
        'get_messages',
        { serial: serial, limit: limit, offset: offset },
        (error, messages = []) => {
          if(error)
            reject(error)
          else
            resolve(messages)
        }
      )
    })
  },
  getLastSeen(serial){
    return new Promise((resolve, reject) => {
      ChatMessageService.io.emit('get_last_seen',{ serial: serial }, (error, lastSeen_time) => {
        if(error)
          reject(error)
        else
          resolve(lastSeen_time)
      })
    })
  },
  sendMessage(payload) {
    return new Promise((resolve, reject) => {
      ChatMessageService.io.emit('send_message', payload, error => {
        if (error) {
          reject(error)
        } else {
          resolve(payload)
        }
      })
    })
  },
  destroyListening(){
    return new Promise((resolve) => {
      ChatMessageService.io.off('message_received', ChatMessageService.onMessageReceived)
      ChatMessageService.io.off('seen_received', ChatMessageService.getLastMessageSeen)
      ChatMessageService.io.off('message_edited', ChatMessageService.onMessageEdited)
      ChatMessageService.io.off('message_deleted', ChatMessageService.onMessageDeleted)
      
      // Quitter la room actuelle si elle existe
      if (ChatMessageService.currentSerial) {
        ChatMessageService.io.emit('leave_room', ChatMessageService.currentSerial)
        ChatMessageService.currentSerial = null
      }
      
      resolve()
    })
  }
}
export default ChatMessageService
